import mitt from 'mitt';

export const Events = {
  ZOOM_EXTENTS: 'zoom-extents',
}

export const eventBus = mitt();